import { render, staticRenderFns } from "./orgUserPerm.vue?vue&type=template&id=6df81018&"
import script from "./orgUserPerm.vue?vue&type=script&lang=js&"
export * from "./orgUserPerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports